import { HtmlDiv } from 'htmlmodule'

export class Content extends HtmlDiv
{
  static class = 'Content'
}
